import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useRequestData, useLabels } from 'wsm-common-data';
import { trackEvent } from 'ddc-track-event';

import {
	CAR_CUSTOMIZER_CONFIRM_HEADING,
	CAR_CUSTOMIZER_CONFIRM_MESSAGE,
	HAVE_FURTHER_QUESTIONS,
	GIVE_US_A_CALL_AT,
	START_A_NEW_VEHICLE_REQUEST
} from '../constants';
import { setVehicleConfiguration } from '../actions/setVehicleConfiguration';
import stepController from '../controllers/StepController';

const Confirm = ({ setCurrentStep }) => {
	setCurrentStep('confirm');
	const labels = useLabels();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { accountData, vehicleConfiguration, rootDir } = useSelector(
		(state) => state
	);
	const { widgetName, windowId } = useRequestData();

	const phoneNumber =
		accountData?.primaryContactInformation?.phoneNumbers?.[0]?.number;

	useEffect(() => {
		if (!vehicleConfiguration.trimName) {
			const lsVehicleConfig = stepController.getLsVehicleConfig();
			if (
				!lsVehicleConfig ||
				!lsVehicleConfig.make ||
				!lsVehicleConfig.model
			) {
				navigate(stepController.getRootPath());
			} else {
				dispatch(setVehicleConfiguration(lsVehicleConfig));
				const trimScreenPath = `/${rootDir}/${lsVehicleConfig.make}/${lsVehicleConfig.model}.htm`;
				navigate(trimScreenPath);
			}
		}
	}, []);

	const sendTrackingEvent = () => {
		trackEvent(widgetName, windowId, {
			element: 'Confirmation page',
			elementCTA: 'start a new vehicle request',
			action: 'clicked',
			result: 'New vehicle request form started'
		});
	};

	return (
		<React.Fragment>
			<i className="ddc-icon ddc-icon-circle-check icon-size-7 text-success" />
			<p className="font-weight-bold">
				{labels.get(CAR_CUSTOMIZER_CONFIRM_HEADING)}
			</p>
			<p>{labels.get(CAR_CUSTOMIZER_CONFIRM_MESSAGE)}</p>
			<p>
				{labels.get(HAVE_FURTHER_QUESTIONS)}
				<br />
				{labels.get(GIVE_US_A_CALL_AT)}{' '}
				<a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
			</p>
			<a
				href={`/${rootDir}/index.htm`}
				onClick={() => sendTrackingEvent()}
			>
				{labels.get(START_A_NEW_VEHICLE_REQUEST)}
			</a>
		</React.Fragment>
	);
};

Confirm.propTypes = {
	setCurrentStep: PropTypes.func
};

export default Confirm;
